export const QUERY_KEYS = {
  AUTH_CURRENT_GET: "AUTH_CURRENT_GET",
  AUTH_LOGIN_POST: "AUTH_LOGIN_POST",
  UNOS_EDITABLE_TEXT_GET: "UNOS_EDITABLE_TEXT_GET",
  UNOS_VIDEO_GET: "UNOS_VIDEO_GET",
  UNOS_VIDEO_SEARCH: "UNOS_VIDEO_SEARCH",
  UNOS_POSITION_GET: "UNOS_POSITION_GET",
  UNOS_POSITION_SEARCH: "UNOS_POSITION_SEARCH",
  UNOS_PANEL_GET: "UNOS_PANEL_GET",
  UNOS_PANEL_SEARCH: "UNOS_PANEL_SEARCH",
  TEST_CONTENT_GET: "TEST_CONTENT_GET",
};
